// src/components/seo/seoGenerator.js
import { WebsiteData } from "./structuredData";

const JSON_LD_PREFIX = "seo-jsonld-";

// Sterge tag-uri SEO existente
function cleanSEOTags() {
  const head = document.head;

  // Meta standard
  head.querySelectorAll("meta[name]").forEach(meta => {
    const name = meta.getAttribute("name");
    if (
      name &&
      ["description", "keywords", "author", "viewport", "robots", "twitter:"].some(tag =>
        name.startsWith(tag)
      )
    ) {
      meta.remove();
    }
  });

  // Open Graph
  head.querySelectorAll('meta[property^="og:"]').forEach(meta => meta.remove());

  // Twitter
  head.querySelectorAll('meta[name^="twitter:"]').forEach(meta => meta.remove());

  // JSON-LD
  head.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
    if (script.id && script.id.startsWith(JSON_LD_PREFIX)) script.remove();
  });
}

// Scrie meta tags in head
function setMetaTags(tags, property = false) {
  const head = document.head;
  Object.entries(tags).forEach(([key, value]) => {
    if (!value) return;
    const meta = document.createElement("meta");
    if (property) meta.setAttribute("property", key);
    else meta.setAttribute("name", key);
    meta.content = value;
    head.appendChild(meta);
  });
}

// Adauga JSON-LD in head
function setStructuredData(jsonLDArray) {
  const head = document.head;
  jsonLDArray.forEach((data, index) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = `${JSON_LD_PREFIX}${Date.now()}-${index}`;
    script.text = JSON.stringify(data);
    head.appendChild(script);
  });
}

// Functia principala de setup SEO
export function setupPage({ meta = {}, og = {}, twitter = {}, structuredData = [] }) {
  cleanSEOTags();
  setMetaTags(meta);
  setMetaTags(og, true);
  setMetaTags(twitter);

  // Construim array-ul final JSON-LD
  const jsonLDArray = [
    new WebsiteData().toJson(),  // schema WebSite global
    ...structuredData            // restul schemelor (PropertyData, ArticleData, BreadcrumbsData etc.)
  ];

  setStructuredData(jsonLDArray);
}
